import isArray from 'lodash/isArray';
import get from 'lodash/get';
import set from 'lodash/set';
import toPath from 'lodash/toPath';

/**
 * Update a value on the state.
 *
 * @param state
 * @param data
 */
export function setDataValue(state, data) {
    const field = toPath(data.field);
    field.shift();
    set(state, field, data.value);
}

/**
 * Retrieve a readonly attribute from the store.
 *
 * @param storePath
 */
export function readOnly(storePath) {
    return get(this.$store.state, storePath);
}

/**
 * So by default the store data is immutable in most scenarios, and
 * it's usually bad practice to modify directly as you lose the ability
 * to rollback state. In order to efficiently use the state in our
 * components, we need to implement a getter/setter combo to both
 * return the data and update the data in the store. We dispatch a
 * generic event on the store to update a piece of data.
 *
 * This can accept an array of store paths or a single string store path.
 * If an array is provided, the return value should make use of the spread
 * operator to bind to the component.
 *
 * You can also pass in an object in the array where the key is the field
 * name to be returned, and the value is the path to the store object
 *
 * @param storePath
 * @param mutationName
 * @param additionalData
 * @returns {*}
 */
export default function storeGetterSetterController(storePath, mutationName = false, additionalData = {}) {
    if (!isArray(storePath)) {
        return storeGetterSetter(storePath, mutationName, additionalData = {});
    }

    let values = {};

    storePath.forEach((path) => {
        let { field, mutation } = getFieldAndPath(path);
        values[field] = storeGetterSetter(
            path,
            mutationName || mutation,
            additionalData = {}
        );
    });

    return values;
}

function getFieldAndPath(path) {
    let field;
    if (typeof path === 'object') {
        field = Object.keys(path)[0];
        path = path[Object.keys(path)[0]];
    } else {
        field = path.split('.').slice(-1);
    }

    let pathComponents = path.split('.');

    module = pathComponents.splice(0, 1);

    let mutation = `${module}/setDataValue`;

    return {
        module,
        field,
        mutation,
    }
}

export function storeGetterSetter(storePath, mutationName, additionalData = {}) {
    let field = getFieldAndPath(storePath);

    mutationName = mutationName || field.mutation;

    return {
        get() {
            if (typeof storePath === 'object') storePath = storePath[Object.keys(storePath)[0]];
            return get(this.$store.state, storePath);
        },

        set(value) {
            if (typeof value === 'undefined') return;
            if (typeof storePath === 'object') storePath = storePath[Object.keys(storePath)[0]];
            return this.$store.commit(mutationName, {
                field: storePath,
                value,
                additionalData,
            });
        }
    };
}
